import { render, staticRenderFns } from "./CadastroInventario.vue?vue&type=template&id=1bce6710&scoped=true"
import script from "./CadastroInventario.vue?vue&type=script&lang=js"
export * from "./CadastroInventario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bce6710",
  null
  
)

export default component.exports